import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import RoutesSwitcher from './components/App/Routes/RoutesSwitcher';
import { AuthProvider } from './contexts/AuthContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { ContentProvider } from './contexts/ContentContext';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfigProvider>
          <ContentProvider>
            <RoutesSwitcher />
          </ContentProvider>
        </ConfigProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;